import React from 'react'
import { useEffect } from 'react'
import useOutsideClick from '../../../hooks/useOutSideClick';
import { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { CheckBoxContainer, CommonDeptLocContainer } from './Filterstyles';
import { Border } from '../../RecogntionAdmin/styles';
import { RecognitionTickIcon } from '../../../utils/icons';

const NewFilterPopup = ({departmentDetails, locationDetails,/*fetchCelebrationsDetailscompanyId,*/ isDropdownOpen, setIsDropdownOpen,activeSubTab,updateDropdown,WellnessInterests,userType,updateWellnessDropdown,filters,selectType,page, updateLocationDropdown}) => {
  const [selectedDepartments, setSelectedDepartments]= useState([]);
  const [selectedLocations, setSelectedLocations]= useState([]);
  const [selectedUsers, setSelectedUsers]= useState([]);
  const [selectedInterests, setSelectedInterests]= useState([]);


  const ref = useOutsideClick(() => {
    setIsDropdownOpen(false);
  });


  useEffect(()=>{
    setSelectedDepartments([]);
    setSelectedLocations([]);
  },[activeSubTab]);


  


  // const handleSelect = (id, selectedItems, setSelectedItems) => {

  //   window.console.log("id, selectedItems, selectType ----", id, selectedItems, selectType);
  //   if (selectType === 'single') {
  //     !selectedItems.includes(id) && setSelectedItems([id]);
  //   } else {
  //     const updatedItems = selectedItems.includes(id)
  //       ? selectedItems.filter((item) => item !== id)
  //       : [...selectedItems, id];
  //     setSelectedItems(updatedItems);
  //   }
  // };




  const handleSelect = (id, setSelectedItems) => {
    setSelectedItems((prevSelected) => {
      if (selectType === "single") {
        return prevSelected.includes(id) ? [] : [id];
      }
  
      return prevSelected.includes(id)
        ? prevSelected.filter((item) => item !== id)
        : [...prevSelected, id];
    });
  };
  
  
  return (
    <>{isDropdownOpen ? 
      <CommonDeptLocContainer ref={ref}   isActiveTab={"1000"}>
        <div className='dept-loc-conteiner'>
          {userType?.length && filters?.includes("user") ? <div className="list-container" >
            <div className="department-title">
              {/* <CheckBoxContainer selected={selectedUsers.length === userType.length ? true : false}  onClick={()=>{
                handleSelectAll(selectedUsers, setSelectedUsers, userType);
                // selectAllUser();
              }}>
                <div className="archive-action">{selectedUsers.length === userType.length ?  RecognitionTickIcon() : null}</div>
              </CheckBoxContainer> */}
              {/* <span className='dept-name'>All Users</span> */}
              <span className='dept-name' style={{marginLeft:"0px"}}>Users</span>
            </div>
            <Border style={{border:"1px solid #EFEFEF",margin:"8px 0px"}}/>
            <div className="department-list">
              {userType.map((user, index)=>(
                <>
                  {<div key={index + "user"} className="department-row" 
                    // onClick={()=>{handleSelect(user.id, selectedUsers, setSelectedUsers); 
                    //   !selectedUsers.includes(user.id) && updateDropdown(
                    //     userType[index].name,
                    //     userType[index].id,
                    //     "selectUserDropDown",
                    //     "selectUserDropDownId"
                    //   )
                    // }}
                    onClick={() => {
                      const isSelected = selectedUsers.includes(user.id);

                      window.console.log("isSelected", isSelected);
                      window.console.log("selectedUsers",selectedUsers)
                    
                      handleSelect(user.id,setSelectedUsers);
                    
                      if (!isSelected) {
                        // selecting
                        updateDropdown(
                          user.name,
                          user.id,
                          "selectUserDropDown",
                          "selectUserDropDownId"
                        );
                      } else {
                        // deselecting
                        updateDropdown(
                          "",          // clear name
                          null,        // clear id
                          "selectUserDropDown",
                          "selectUserDropDownId"
                        );
                      }
                    }}

                  >
                    <CheckBoxContainer selected={selectedUsers.includes(user.id) ? true : false} selectType={selectType}>
                      <div className="archive-action" >{selectedUsers.includes(user.id) ?  RecognitionTickIcon() : null}</div>
                    </CheckBoxContainer>
                    <span className='dept-name'>{user.name}</span>
                  </div>}
                </>
              ))}
            </div>
          </div>:null}
          {departmentDetails?.length && filters?.includes("department") ? <div className="list-container">
            <div className="department-title">
              {/* <CheckBoxContainer selected={selectedDepartments.length === departmentDetails.length ? true : false}  onClick={()=>{
                handleSelectAll(selectedDepartments, setSelectedDepartments, departmentDetails);
                // selectAllDepartments();
              }}>
                <div className="archive-action">{selectedDepartments.length === departmentDetails.length ?  RecognitionTickIcon() : null}</div>
              </CheckBoxContainer> */}
              {/* <span className='dept-name'>All Departments</span> */}
              <span className='dept-name' style={{marginLeft:"0px"}}>Departments</span>
            </div>
            <Border style={{border:"1px solid #EFEFEF",margin:"8px 0px"}}/>
            <div className="department-list">
              {departmentDetails?.map((department, index)=>(
                <>
                  {<div key={index + 'department'} className="department-row" 
                    // onClick={()=>{
                    //   handleSelect(department.id || department.department, selectedDepartments, setSelectedDepartments);
                    //   // SelectDepartment(department.id);
                    //   if(!selectedDepartments.includes(department.id || department.department)){
                    //     if(page === "inactive"){
                    //       updateDropdown(departmentDetails[index].department,index, departmentDetails[index].department)
     
                    //     }else{
                    //       updateDropdown(
                    //         departmentDetails[index].department,
                    //         departmentDetails[index].id,
                    //         "department",
                    //         "departmentId"
                    //       )
     
                    //     }
                    //   }
  
  
                    // }}



                    onClick={() => {
                      const departmentKey = department.id || department.department;
                      const isSelected = selectedDepartments.includes(departmentKey);

                      window.console.log("selectedDepartments",selectedDepartments)
                      handleSelect(
                        departmentKey,
                        setSelectedDepartments
                      );
                    
                      if (!isSelected) {
                        // SELECT
                        if (page === "inactive") {
                          updateDropdown(
                            department.department,
                            index,
                            department.department
                          );
                        } else {
                          updateDropdown(
                            department.department,
                            department.id,
                            "department",
                            "departmentId"
                          );
                        }
                      } else {
                        // DESELECT
                        if (page === "inactive") {
                          updateDropdown("", null, "");
                        } else {
                          updateDropdown(
                            "",
                            null,
                            "department",
                            "departmentId"
                          );
                        }
                      }
                    }}
                  >
                    <CheckBoxContainer selected={selectedDepartments.includes(department.id || department.department) ? true : false} selectType={selectType}>
                      <div className="archive-action" >{selectedDepartments.includes(department.id || department.department) ?  RecognitionTickIcon() : null}</div>
                    </CheckBoxContainer>
                    <span className='dept-name'>{department.department}</span>
                  </div>}
                </>
              ))}
            </div>
          </div>:null}
          {locationDetails?.length && filters?.includes("location") ? <div className="list-container">
            <div className="department-title">
              {/* <CheckBoxContainer selected={selectedLocations.length === locationDetails.length ? true : false} onClick={()=>{
                handleSelectAll(selectedLocations, setSelectedLocations, locationDetails);
                // selectAllLocations();
              }}>
                <div className="archive-action" >{selectedLocations.length === locationDetails.length ?  RecognitionTickIcon() : null}</div>
              </CheckBoxContainer> */}
              {/* <span className='dept-name'>All Locations</span> */}
              <span className='dept-name' style={{marginLeft:"0px"}}>Locations</span>
            </div>
            <Border style={{border:"1px solid #EFEFEF",margin:"8px 0px"}}/>
            <div className="department-list">
              {locationDetails?.map((location, index)=>(
                <>
                  {
                    <div key={index + 'location'} className="department-row" 
                      // onClick={()=>{
                      //   handleSelect(location.id ||  location.location, selectedLocations, setSelectedLocations);
                      //   // SelectLocation(location.id ||  location.location);  
                      //   if(!selectedLocations.includes(location.id ||  location.location)){
                      //     if(page === "inactive"){
                      //       updateLocationDropdown(locationDetails[index].location, index, locationDetails[index].location)
     
                      //     }else{
                      //       updateDropdown(
                      //         locationDetails[index].state &&
                      //           locationDetails[index].city
                      //           ? locationDetails[index].city +
                      //               ", " +
                      //               locationDetails[index].state
                      //           : locationDetails[index].state ===
                      //               null && locationDetails[index].city
                      //             ? locationDetails[index].city
                      //             : locationDetails[index].state &&
                      //                   locationDetails[index].city === null
                      //               ? locationDetails[index].state
                      //               : null,
                      //         locationDetails[index].id,
                      //         "locationDropDown",
                      //         "locationDropDownId"
                      //       )
                      //     } 
                      //   } 
                      // }}

                      onClick={() => {
                        const locationKey = location.id || location.location;
                        const isSelected = selectedLocations.includes(locationKey);
                      
                        handleSelect(locationKey, setSelectedLocations);
                      
                        if (!isSelected) {
                          // SELECT
                          if (page === "inactive") {
                            updateLocationDropdown(
                              locationDetails[index].location,
                              index,
                              locationDetails[index].location
                            );
                          } else {
                            updateDropdown(
                              locationDetails[index].state && locationDetails[index].city
                                ? `${locationDetails[index].city}, ${locationDetails[index].state}`
                                : locationDetails[index].city
                                  ? locationDetails[index].city
                                  : locationDetails[index].state,
                              locationDetails[index].id,
                              "locationDropDown",
                              "locationDropDownId"
                            );
                          }
                        } else {
                          // DESELECT
                          if (page === "inactive") {
                            updateLocationDropdown("", null, "");
                          } else {
                            updateDropdown("", null, "locationDropDown", "locationDropDownId");
                          }
                        }
                      }}

                    >
                      <CheckBoxContainer selected={selectedLocations.includes(location.id ||  location.location) ? true : false} selectType={selectType}>
                        <div className="archive-action">{selectedLocations.includes(location.id ||  location.location) ?  RecognitionTickIcon() : null}</div>
                      </CheckBoxContainer>
                      <span className='dept-name'>{location.location}</span>
                    </div>}
                </>
              ))}
            </div>
          </div>:null}
          {WellnessInterests?.length && filters?.includes("interest") ? <div className="list-container">
            <div className="department-title">
              {/* <CheckBoxContainer selected={selectedInterests?.length === WellnessInterests?.length ? true : false} onClick={()=>
                handleSelectAll(selectedInterests, setSelectedInterests, WellnessInterests)}>
                <div className="archive-action" >{selectedInterests.length === WellnessInterests?.length ?  RecognitionTickIcon() : null}</div>
              </CheckBoxContainer>
              <span className='dept-name'>All Interests</span> */}
              <span className='dept-name' style={{marginLeft:"0px"}}>Interests</span>
            </div>
            <Border style={{border:"1px solid #EFEFEF",margin:"8px 0px"}}/>
            <div className="department-list">
              {WellnessInterests?.map((interest, index)=>(
                <>
                  {
                    <div key={index + 'interest'} className="department-row" 
                      // onClick={()=>{
                      //   handleSelect(interest.id, selectedInterests, setSelectedInterests);
                      //   // SelectLocation(interest.id);                      
                      //   !selectedInterests.includes(interest.id) && updateWellnessDropdown(
                      //     WellnessInterests[index].name,
                      //     WellnessInterests[index].id,
                      //     "wellnessInterestId",
                      //     "wellnessInterest"  
                      //   );}}

                      onClick={() => {
                        const isSelected = selectedInterests.includes(interest.id);
                      
                        handleSelect(interest.id, setSelectedInterests);
                      
                        if (!isSelected) {
                          // SELECT
                          updateWellnessDropdown(
                            interest.name,
                            interest.id,
                            "wellnessInterestId",
                            "wellnessInterest"
                          );
                        } else {
                          // DESELECT
                          updateWellnessDropdown(
                            "",
                            null,
                            "wellnessInterestId",
                            "wellnessInterest"
                          );
                        }
                      }}

                    >
                      <CheckBoxContainer selected={selectedInterests?.includes(interest.id) ? true : false} selectType={selectType}>
                        <div className="archive-action">{selectedInterests?.includes(interest.id) ?  RecognitionTickIcon() : null}</div>
                      </CheckBoxContainer>
                      <span className='dept-name'>{interest.name}</span>
                    </div>}
                </>
              ))}
            </div>
          </div>:null}
        </div>
      </CommonDeptLocContainer>
      : null}</>
  )
}

NewFilterPopup.propTypes = {
  departmentDetails: PropTypes.array,
  locationDetails: PropTypes.array,
  isDropdownOpen: PropTypes.bool, 
  setIsDropdownOpen: PropTypes.func,
  fetchCelebrationsDetails: PropTypes.func,
  companyId: PropTypes.number,
  activeSubTab: PropTypes.string,
  updateDropdown:PropTypes.func,
  WellnessInterests:PropTypes.array,
  userType:PropTypes.array,
  updateWellnessDropdown:PropTypes.func,
  filters:PropTypes.array,
  selectType:PropTypes.string,
  page:PropTypes.string,
  updateLocationDropdown:PropTypes.string,
}

// const mapStateToProps = (state) => ({
//   departmentDetails: state.companyDashboard.companyPeopleDepartment,
//   locationDetails: state.companyDashboard.companyPeopleLocation,
  
// })

export default connect(null, null)((NewFilterPopup));